
export const imageUrl = (params: { filename?: string, url?: string}): string => {
  if (!params) return undefined
  const { filename, url } = params
  if (!filename && !url) 
    return undefined
  return url ?? process.env.REACT_APP_UPLOADS_URL + '/' + filename
}
